import {Provider} from 'react-redux';
import {renderElement} from '@Utils/root-element.util';
import type {AutoBrandingProps} from '@Components/auto-branding/auto-branding';
import {AutoBranding} from '@Components/auto-branding/auto-branding';

window.PMW.mergePMW(PMW, {
  /**
   * @param {HTMLElement} containerElement
   * @param {object} opts
   * @param {object|null} [opts.appliedColorPalette]
   * @param {number} [opts.appliedColorPalette.id]
   * @param {string} [opts.appliedColorPalette.name]
   * @param {string[]} [opts.appliedColorPalette.colors] containing upto 5 hex colors (one is required others are optional)
   * @param {function} [opts.onPaletteAdd]
   * @param {function} [opts.onPaletteSelect]
   * @param {function} [opts.onPaletteEdit]
   */
  renderAutoBranding(containerElement: HTMLElement, opts: AutoBrandingProps) {
    renderElement(
      containerElement,
      <Provider store={window.PMW.redux.store}>
        <AutoBranding {...opts} />
      </Provider>
    );
  },
});
